export default __webpack_public_path__ + "static/media/Mark-6-HUD-07.8c6b5f04.jpg";